export default __webpack_public_path__ + "static/media/slide2.1a47e927.jpeg";